var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20 10.4477 20.4477 10 21 10C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14C20.4477 14 20 13.5523 20 13V11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H17C18.1046 18 19 17.1046 19 16V8C19 6.89543 18.1046 6 17 6H4ZM12.0303 9.53033L10.3107 11.25H12.5C12.8033 11.25 13.0768 11.4327 13.1929 11.713C13.309 11.9932 13.2448 12.3158 13.0303 12.5303L10.0303 15.5303C9.73744 15.8232 9.26256 15.8232 8.96967 15.5303C8.67678 15.2374 8.67678 14.7626 8.96967 14.4697L10.6893 12.75H8.5C8.19665 12.75 7.92318 12.5673 7.80709 12.287C7.691 12.0068 7.75517 11.6842 7.96967 11.4697L10.9697 8.46967C11.2626 8.17678 11.7374 8.17678 12.0303 8.46967C12.3232 8.76256 12.3232 9.23744 12.0303 9.53033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.d1fc3ba78a17aea5a9d0235772904215.svg";
export { ForwardRef as ReactComponent };